import {PaymentDetails} from "@bounce/shared/consumer/declarations";
import {IResponseData, PaymentError} from "@bounce/shared/consumer/pages/payment";
import {BaseMutationOptions, BaseUseMutationResult, useIdempotentPayment} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = PaymentDetails & {
  account_id: string;
  is_partial_payment?: boolean;
  resolve_additional_balance_outside_plan?: boolean;
  payment_plan_id?: string;
  payment_method_id?: number;
};

type Data = IResponseData;

const singlePayment = async (variables: Variables, idempotencyKey: string): Promise<Data> => {
  const {account_id, ...data} = variables;
  const result = await axiosConsumerAppInstance.post<Data, AxiosResponse<Data>>(
    `/payments/single/${account_id}`,
    data,
    {
      headers: {"Idempotency-Key": idempotencyKey},
    }
  );

  if (!result.data?.success) {
    throw new PaymentError(
      result.data.error_message,
      result.data.error_reason,
      result.data.error_explanation,
      result.data.error_origin,
      result.data.error_code
    );
  }
  return result.data;
};

export const useSinglePayment = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => {
  return useIdempotentPayment(singlePayment, {
    refetchType: "all",
    ...options,
    prefixKeysToInvalidate: (data, variables) => [
      ["user"],
      ["account", variables.account_id, "dashboard"],
      ["account", variables.account_id],
    ],
  });
};
